import { DialogDraftsLocalStore } from "../../utility/dialogs/dialogDraftsStore"

export const dialogDraftsLocalStoreDriver = new DialogDraftsLocalStore<string>("dialogDraftsStore")
